import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { injectIntl } from "react-intl"
import LoadingSpinner from "../../common/spinner/loading.component"
import { SchedulerEditorModalProps } from "../../common/types/scheduling"
import IntlProps from "../../state/helpers/IntlProps"
import NylasSchedulerEditor from "./NylasSchedulerEditor"

const SchedulerEditorModal = (props: SchedulerEditorModalProps & IntlProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const handleCloseModal = (modalChanged: boolean) => {
        props.isModalChangedCallback(modalChanged)
    }

    return (
        <Modal 
            show={true} 
            onHide={handleCloseModal} 
            centered 
            backdrop="static"
            animation={true}
            size="lg" >
            {isLoading && <Modal.Body>
                <div className="container-fluid">
                    <LoadingSpinner className="pt-4" />
                </div>
            </Modal.Body>}

            <NylasSchedulerEditor 
                externalAccountId={props.externalAccountId} 
                configurationId={props.configurationId} 
                userName={props.userName}
                urlLink={props.urlLink}
                isModalChangedCallback={handleCloseModal}
                isLoadingCallback={(newLoading) => newLoading !== isLoading && setIsLoading(newLoading)}
            />
        </Modal>
    )

}

export default injectIntl(SchedulerEditorModal)


// WEBPACK FOOTER //
// ./src/scheduling-page/nylasv3/SchedulerEditorModal.tsx